import React, { useContext } from "react";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";

import { ConfiguracionContext } from "../../../../context/ConfiguracionContext";
import MaestroArchivo from "../../common/MaestroArchivo";

export default function Almacenes() {
  const { almacenes, obtenerAlmacenes, agregarAlmacen, actualizarAlmacen } =
    useContext(ConfiguracionContext);

  return (
    <MaestroArchivo
      titulo="Almacenes"
      entidad="almacén"
      layout="Almacenes"
      icono={<Inventory2OutlinedIcon />}
      items={almacenes}
      onObtener={() => obtenerAlmacenes({ todos: true })}
      onAgregar={(data) => agregarAlmacen({ almacen: data })}
      onActualizar={(data) => actualizarAlmacen({ almacen: data })}
    />
  );
}
